module.exports = __webpack_public_path__ + "img/Lightbulb-Moment_light.25890f52.png";